
export const INITIAL_STATE_COMPOSITION = {
  id: "",
  idProduto: "",
  quantidade: 1,
  dadosAdicionais: "",
}